import { VideoPreviewData } from './components/VideoPreviewModal';

export interface CommunityVideoEntry extends VideoPreviewData {
  videoType: string;
  views: string;
  likes: number;
}

export const COMMUNITY_VIDEOS: CommunityVideoEntry[] = [
  {
    id: 'cv1',
    prompt: 'A luxury penthouse at sunset with floor-to-ceiling glass walls, warm golden light flooding the interior, slow cinematic dolly-in revealing a perfectly set dining table',
    thumbnail: 'https://public.readdy.ai/ai/img_res/32fa3b0ad410d4a9fd81caf065ed245d.jpg',
    author: 'Mia Torres',
    avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20professional%20headshot%20warm%20smile%20confident%20portrait%20minimal%20background&width=80&height=80&seq=av001&orientation=squarish',
    views: '84.2K',
    likes: 1420,
    style: 'Cinematic',
    duration: '30s',
    videoType: 'Marketing',
  },
  {
    id: 'cv2',
    prompt: 'Deep-ocean bioluminescent jellyfish drift through dark blue water, surrounded by glowing particles, otherworldly atmosphere with gentle slow-motion movement',
    thumbnail: 'https://readdy.ai/api/search-image?query=bioluminescent%20jellyfish%20deep%20ocean%20glowing%20blue%20particles%20dark%20water%20ethereal%20magical%20underwater%20scene%20beautiful%20light%20rays&width=480&height=270&seq=cv002&orientation=landscape',
    author: 'Luca Ferraro',
    avatar: 'https://readdy.ai/api/search-image?query=young%20man%20creative%20professional%20confident%20smile%20portrait%20clean%20background%20studio%20lighting&width=80&height=80&seq=av002&orientation=squarish',
    views: '221K',
    likes: 5830,
    style: 'Realistic',
    duration: '60s',
    videoType: 'Documentary',
  },
  {
    id: 'cv3',
    prompt: 'Colorful animated character runs through a vibrant candy-colored city at night, neon signs flinking, smooth Pixar-style 3D animation with expressive movements',
    thumbnail: 'https://readdy.ai/api/search-image?query=colorful%203d%20animated%20city%20night%20neon%20lights%20vibrant%20character%20cartoon%20pixar%20style%20bright%20colors%20fun%20energetic%20urban%20environment&width=480&height=270&seq=cv003&orientation=landscape',
    author: 'Priya Shah',
    avatar: 'https://readdy.ai/api/search-image?query=woman%20creative%20designer%20smiling%20portrait%20colorful%20background%20studio%20professional%20headshot&width=80&height=80&seq=av003&orientation=squarish',
    views: '154K',
    likes: 3210,
    style: 'Animated',
    duration: '15s',
    videoType: 'Social Media',
  },
  {
    id: 'cv4',
    prompt: 'Abstract geometric shapes morph and flow through a dark void, vibrant neon gradients, fluid transitions revealing hidden patterns — perfect for a tech brand opener',
    thumbnail: 'https://readdy.ai/api/search-image?query=abstract%20geometric%20neon%20gradient%20dark%20background%20flowing%20shapes%20morphing%20patterns%20tech%20brand%20motion%20design%20luxury%20premium%20digital%20art&width=480&height=270&seq=cv004&orientation=landscape',
    author: 'Jordan Kim',
    avatar: 'https://readdy.ai/api/search-image?query=person%20professional%20headshot%20neutral%20background%20confident%20creative%20modern%20style%20portrait&width=80&height=80&seq=av004&orientation=squarish',
    views: '67.8K',
    likes: 2104,
    style: 'Abstract',
    duration: '30s',
    videoType: 'Marketing',
  },
  {
    id: 'cv5',
    prompt: "Chef's hands expertly plating a michelin-star dish, close-up macro shots of sauces being drizzled, steam rising, warm kitchen light, cinematic food photography aesthetic",
    thumbnail: 'https://readdy.ai/api/search-image?query=michelin%20star%20fine%20dining%20chef%20plating%20food%20macro%20close%20up%20steam%20warm%20restaurant%20kitchen%20light%20gourmet%20elegant%20culinary%20art&width=480&height=270&seq=cv005&orientation=landscape',
    author: 'Elena Vasquez',
    avatar: 'https://readdy.ai/api/search-image?query=woman%20chef%20professional%20portrait%20kitchen%20background%20confident%20smile%20culinary%20arts%20headshot&width=80&height=80&seq=av005&orientation=squarish',
    views: '310K',
    likes: 8920,
    style: 'Cinematic',
    duration: '30s',
    videoType: 'Social Media',
  },
  {
    id: 'cv6',
    prompt: 'A timelapse of a desert landscape from dawn to dusk, dramatic cloud shadows sweeping across golden sand dunes, milky way appearing at night, ultra-wide angle',
    thumbnail: 'https://readdy.ai/api/search-image?query=desert%20landscape%20timelapse%20golden%20sand%20dunes%20dramatic%20light%20clouds%20shadows%20milky%20way%20night%20sky%20wide%20angle%20photography%20stunning%20nature&width=480&height=270&seq=cv006&orientation=landscape',
    author: 'Omar Hassan',
    avatar: 'https://readdy.ai/api/search-image?query=man%20photographer%20outdoors%20professional%20portrait%20natural%20light%20confident%20travel%20documentary&width=80&height=80&seq=av006&orientation=squarish',
    views: '189K',
    likes: 4590,
    style: 'Realistic',
    duration: '60s',
    videoType: 'Documentary',
  },
  {
    id: 'cv7',
    prompt: 'Neon-lit cyberpunk city street at night with rain reflections, holographic advertisements, crowds of pedestrians with glowing tech implants, handheld camera movement',
    thumbnail: 'https://readdy.ai/api/search-image?query=cyberpunk%20city%20neon%20rain%20night%20futuristic%20street%20holographic%20ads%20cinematic%20moody%20atmospheric%20dark%20sci-fi%20urban%20environment&width=480&height=270&seq=cv007&orientation=landscape',
    author: 'Yuki Tanaka',
    avatar: 'https://readdy.ai/api/search-image?query=japanese%20creative%20professional%20portrait%20studio%20neutral%20background%20young%20confident%20smile&width=80&height=80&seq=av007&orientation=squarish',
    views: '445K',
    likes: 12300,
    style: 'Cinematic',
    duration: '60s',
    videoType: 'Film',
  },
  {
    id: 'cv8',
    prompt: 'Tiny animated fairy-tale village built inside a giant mushroom, soft glowing windows, fireflies dancing around the mushroom cap, magical night atmosphere',
    thumbnail: 'https://readdy.ai/api/search-image?query=magical%20fairy%20tale%20mushroom%20village%20tiny%20houses%20glowing%20windows%20fireflies%20night%20fantasy%20animated%20colorful%20whimsical%20miniature%20enchanted%20forest&width=480&height=270&seq=cv008&orientation=landscape',
    author: 'Sofia Reyes',
    avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20artist%20creative%20professional%20warm%20smile%20colorful%20studio%20background%20portrait&width=80&height=80&seq=av008&orientation=squarish',
    views: '178K',
    likes: 5670,
    style: 'Animated',
    duration: '30s',
    videoType: 'Animation',
  },
];

export function getRelatedVideos(current: VideoPreviewData & { videoType?: string }, count = 4): CommunityVideoEntry[] {
  const others = COMMUNITY_VIDEOS.filter(v => v.id !== current.id);
  const sameStyle = others.filter(v => v.style === current.style);
  const sameType = others.filter(v => v.videoType === current.videoType && v.style !== current.style);
  const rest = others.filter(v => v.style !== current.style && v.videoType !== current.videoType);
  return [...sameStyle, ...sameType, ...rest].slice(0, count);
}
